import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import StaffPage from './pages/StaffPage';
import ContactPage from './pages/ContactPage';
import PageRenderer from './components/PageRenderer';

// ScrollToTop component to reset scroll position on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50/20 text-slate-800 antialiased font-sans">
      {/* Scroll to top on route change */}
      <ScrollToTop />

      {/* Header Navigation */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          {/* Home Route */}
          <Route path="/" element={<Home />} />

          {/* Contact Route */}
          <Route path="/contact" element={<ContactPage />} />

          {/* Staff Route */}
          <Route path="/medarbejdere" element={<StaffPage />} />

          {/* Dynamic CMS Page Route */}
          <Route path="/:slug" element={<PageRenderer />} />
        </Routes>
      </main>

      {/* Footer Section */}
      <Footer />
    </div>
  );
}

export default App;
